import { createGlobalState } from '@vueuse/core'

export const useRodoStore = createGlobalState(() => {
  const topic = ref<null | number>(null)
  const isUsingProduct = ref<null | boolean>(null)
  const step = ref(0)

  return {
    topic,
    isUsingProduct,
    step,
  }
})
